import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type AddBoxProps = IconComponentBaseProps;

export const AddBox = ({
  className,
  width = 16,
  height = 16,
  fill = defaultTheme.mantineColors.gray[7],
}: AddBoxProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_7237_100229"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="17"
      >
        <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7237_100229)">
        <path
          d="M7.50016 8.99967V11.1663C7.50016 11.3082 7.54805 11.427 7.64383 11.5227C7.7395 11.6185 7.85827 11.6663 8.00016 11.6663C8.14205 11.6663 8.26083 11.6185 8.3565 11.5227C8.45227 11.427 8.50016 11.3082 8.50016 11.1663V8.99967H10.6668C10.8087 8.99967 10.9275 8.95179 11.0232 8.85601C11.1189 8.76034 11.1668 8.64156 11.1668 8.49967C11.1668 8.35779 11.1189 8.23901 11.0232 8.14334C10.9275 8.04756 10.8087 7.99967 10.6668 7.99967H8.50016V5.83301C8.50016 5.69112 8.45227 5.57234 8.3565 5.47667C8.26083 5.3809 8.14205 5.33301 8.00016 5.33301C7.85827 5.33301 7.7395 5.3809 7.64383 5.47667C7.54805 5.57234 7.50016 5.69112 7.50016 5.83301V7.99967H5.3335C5.19161 7.99967 5.07283 8.04756 4.97716 8.14334C4.88138 8.23901 4.8335 8.35779 4.8335 8.49967C4.8335 8.64156 4.88138 8.76034 4.97716 8.85601C5.07283 8.95179 5.19161 8.99967 5.3335 8.99967H7.50016ZM3.53866 14.1663C3.20188 14.1663 2.91683 14.0497 2.6835 13.8163C2.45016 13.583 2.3335 13.298 2.3335 12.9612V4.03817C2.3335 3.7014 2.45016 3.41634 2.6835 3.18301C2.91683 2.94967 3.20188 2.83301 3.53866 2.83301H12.4617C12.7984 2.83301 13.0835 2.94967 13.3168 3.18301C13.5502 3.41634 13.6668 3.7014 13.6668 4.03817V12.9612C13.6668 13.298 13.5502 13.583 13.3168 13.8163C13.0835 14.0497 12.7984 14.1663 12.4617 14.1663H3.53866ZM3.53866 13.1663H12.4617C12.513 13.1663 12.56 13.145 12.6027 13.1022C12.6454 13.0595 12.6668 13.0125 12.6668 12.9612V4.03817C12.6668 3.98684 12.6454 3.93984 12.6027 3.89717C12.56 3.8544 12.513 3.83301 12.4617 3.83301H3.53866C3.48733 3.83301 3.44033 3.8544 3.39766 3.89717C3.35488 3.93984 3.3335 3.98684 3.3335 4.03817V12.9612C3.3335 13.0125 3.35488 13.0595 3.39766 13.1022C3.44033 13.145 3.48733 13.1663 3.53866 13.1663Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
